import React, { useState } from "react";
import styles from "../../assets/scss/Invoice/AddInvoice.module.scss";
import { useNavigate, useLocation } from "react-router-dom";
import { useVieGetMyInvoicesselfQuery } from "../../slices/admin/admin";
import { BaseURL } from "../../lib/api";
import ImagePriview from '../../Components/Common/ImagePriview';

const ViewInvoice = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { invoiceId } = location.state || {};

    const { data, isLoading, error } = useVieGetMyInvoicesselfQuery(invoiceId);
    const [selectedImage, setSelectedImage] = useState(null);


    // ✅ Handles both full and relative image URLs safely
    const resolveImageUrl = (path) => {
        if (!path) return "https://via.placeholder.com/40";
        return path.startsWith("http")
            ? path
            : `${BaseURL.replace(/\/$/, "")}/${path.replace(/^\/+/, "")}`;
    };


    const handleCancel = () => navigate(-1);

    if (isLoading) return <p className={styles.loading}>Loading Invoice...</p>;
    if (error) return <p className={styles.error}>Failed to load invoice</p>;

    const invoice = data?.myInvoices?.[0] || {};
    const totalQuantity = invoice.items?.reduce(
        (acc, item) => acc + Number(item.productQuantity || 0),
        0
    ) || 0;
    const totalItems = invoice.items?.length || 0;

    return (
        <div className={styles.invoiceContainer}>
            <div className={styles.header}>
                <h2 className={styles.tittle}>View Invoice</h2>
                <span className={styles.closeIcon} onClick={handleCancel}>×</span>
            </div>

            <div className={styles.AddInvoicehead}>
                {/* Store Info */}
                <div className={styles.ownerCards}>
                    <p><strong>Store Name :</strong> {invoice.invoiceStore?.storeName}</p>
                    <p><strong>Address :</strong> {invoice.invoiceStore?.address1}, {invoice.invoiceStore?.city}, {invoice.invoiceStore?.state}</p>
                </div>

                {/* Invoice Details */}
                <div className={styles.ownerCards}>
                    <p><strong>Invoice No :</strong> {invoice.invoiceNumber}</p>
                    <p><strong>Invoice Date :</strong> {invoice.createdAt ? new Date(invoice.createdAt).toLocaleDateString() : "-"}</p>
                    <p><strong>Sale Commission :</strong> {invoice.saleCommission ?? "-"}</p>
                    <p><strong>Transport Status :</strong> {invoice.logisticStatus ?? "-"}</p>
                    <p><strong>Transport Amount :</strong> ₹{invoice.amount ?? "0"}</p>
                    <p><strong>Transport Paid By :</strong> {invoice.logisticsPaymentBy ?? "-"}</p>
                    <p><strong>Invoice Status :</strong> {invoice.status ?? "-"}</p>
                </div>

                {/* Items Table */}
                <div className={styles.tableWrapper}>
                    <table>
                        <thead>
                            <tr>
                                <th>Seq</th>
                                <th>Item Name</th>
                                <th>Description</th>
                                <th>Quantity</th>
                                <th>Count</th>
                                <th>Quality</th>
                                <th>Bags</th>
                                <th>Image</th>
                            </tr>
                        </thead>
                        <tbody>
                            {invoice.items?.length > 0 ? (
                                invoice.items.map((item, index) => (
                                    <tr key={item._id}>
                                        <td>{index + 1}</td>
                                        <td>{item.productName}</td>
                                        <td>{item.description}</td>
                                        <td>{item.productQuantity || "-"}</td>
                                        <td>{item.productCount || "-"}</td>
                                        <td>{item.productQuality}</td>
                                        <td>{item.productBag}</td>
                                        <td>
                                            {/* <img
                                                src={item.profile ? `${BaseURL}${item.profile}` : "https://via.placeholder.com/40"}
                                                alt={item.productName}
                                                width="40"
                                                height="40"
                                                style={{ objectFit: "cover", borderRadius: "4px", cursor: "pointer" }}
                                                onClick={() => setSelectedImage(item.profile ? `${BaseURL}${item.profile}` : null)}
                                            /> */}
                                            <img
                                                src={resolveImageUrl(item.profile)}
                                                alt={item.productName}
                                                width="40"
                                                height="40"
                                                style={{ objectFit: "cover", borderRadius: "4px", cursor: "pointer" }}
                                                //onError={(e) => (e.target.src = "https://via.placeholder.com/40")}
                                                onClick={() => setSelectedImage(resolveImageUrl(item.profile))}
                                            />

                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="8">No items found</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                {/* Total Item Count Card */}
                <div className={styles.summaryCard}>
                    <div className={styles.totalBox}>
                        <h4 className={styles.totalhead}>Total Item Count</h4>
                        <div className={styles.row}>
                            <p><strong>Total Quantity:</strong> {totalQuantity}</p>
                            <p><strong>Total Item Scales:</strong> {totalItems.toString().padStart(2, "0")}</p>
                        </div>
                    </div>

                    <div className={styles.countBox}>
                        <div className={styles.countflex}>
                            <p><strong>Total Item Count</strong></p>
                            <h2>{totalItems}</h2>
                        </div>
                        <hr />
                        <div className={styles.countflex}>
                            <p>Total</p>
                            <h2>{totalItems}</h2>
                        </div>
                    </div>
                </div>
            </div>

            {/* Image Preview Modal */}
            {selectedImage && (
                <ImagePriview
                    isOpen={true}
                    imageUrl={selectedImage}
                    onClose={() => setSelectedImage(null)}
                />
            )}
        </div>
    );
};

export default ViewInvoice;
